import BenchlingConfig from 'BenchlingConfig';
import {EntityStoreUser} from 'constants/EntityStoreConstants';
import {hasUnlimitedSpace} from 'growth/SpaceUtil';

export default function getFileUploadMaxSizeBytes(user: EntityStoreUser): number {
  if (user.institution && hasUnlimitedSpace(user) && BenchlingConfig.ELN_MAX_FILE_UPLOAD_UNLIMITED_SPACE_MB) {
    return BenchlingConfig.ELN_MAX_FILE_UPLOAD_UNLIMITED_SPACE_MB * 1024 * 1024;
  }
  return BenchlingConfig.ELN_MAX_FILE_UPLOAD_SIZE_MB * 1024 * 1024;
}
